import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelatorioPagamentoDecendialComponent } from './pages/relatorio-pagamento-decendial/relatorio-pagamento-decendial.component';



@NgModule({
  declarations: [
    RelatorioPagamentoDecendialComponent
  ],
  imports: [
    CommonModule
  ]
})
export class IntervenienteLiquidanteModule { }
